export default __webpack_public_path__ + "static/media/Snd_ClowerR.74bef965.mp3";